import { useRouter } from "next/router";
import { useEffect } from "react";
import { getCampaignName } from "./organicTraficMapping";

const useConversionTracking = () => {
  const router = useRouter();

  useEffect(() => {
    // track conversions originated by organic search
    const referrer = document.referrer;
    const organicCampaign = getCampaignName(referrer);

    // TODO: abstract getting a crm_campaign session item into a separate funciton
    if (!sessionStorage.getItem("crm_campaign") && organicCampaign) {
      sessionStorage.setItem("crm_campaign", organicCampaign);
    }

    // override crm_campaign if UTM tag is present
    const query = router.query;
    if (query?.sc_camp) {
      sessionStorage.setItem("crm_campaign", `${query.sc_camp}`);
    }
    if (query?.utm_campaign) {
      sessionStorage.setItem("crm_campaign", `${query.utm_campaign}`);
    }
    if (query?.utm_Campaign) {
      sessionStorage.setItem("crm_campaign", `${query.utm_Campaign}`);
    }
    if (query?.utm_event) {
      sessionStorage.setItem("EventCode", `${query.utm_event}`);
    }
  }, [router]);
};

export default useConversionTracking;
